<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="backgroud-gray-popup popup-content-area-small" v-loading="isSaving" element-loading-spinner="el-icon-loading" element-loading-text="保存中...">
      <el-form>
        <el-form-item v-if="batchSetType == 'minute'" label="课程时长(分钟)：" label-width="200px" class="label-strong">
          <el-input-number v-model="editingCourseMinutes" :min="30" :max="600" :step="30" size="small" style="width:200px;">
          </el-input-number>
        </el-form-item>
        <el-form-item v-if="batchSetType == 'university'" label="所属大学：" class="label-strong">
          <el-select v-model="editingCourseUniversityList" multiple placeholder="请选择大学" size="small">
            <el-option v-for="item in universityList" :key="item.Id" :label="item.Abbreviation" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="batchSetType == 'campus'" label="所属校区：" class="label-strong">
          <el-select v-model="editingCourseCampusList" multiple placeholder="请选择校区" size="small">
            <el-option v-for="item in campusList" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="batchSetType == 'contract'" label="合同：" class="label-strong">
          <el-select v-model="editingContractId" placeholder="请选择合同" size="small">
            <el-option v-for="item in contractList" :key="item.Value" :label="item.Text" :value="item.Value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="20" :xs="16" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
        </el-col>
        <el-col class="footer-right" :span="4" :xs="8">
          <el-button :type="submitBtnClass" :loading="isSaving" @click="save()">确认修改</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  batchSetSpeedUpCourseList,
  batchSetContract,
} from "../service/speedupCourse.service";
export default {
  props: [
    "selectedCourses",
    "batchSetType",
    "universityList",
    "campusList",
    "contractList",
  ],
  data() {
    return {
      showError: false,
      isSaving: false,
      errorMessage: "",
      submitBtnClass: "primary",
      editingCourseMinutes: 180,
      editingCourseUniversityList: [],
      editingCourseCampusList: [],
      editingContractId: null,
    };
  },
  created() {},
  watch: {},
  methods: {
    async save() {
      if (
        this.selectedCourses !== undefined &&
        this.selectedCourses.length > 0
      ) {
        this.isSaving = true;

        if (this.batchSetType === "contract") {
          let courseIds = this.selectedCourses.map((item) => item.Id);
          let result = await batchSetContract(
            courseIds,
            this.editingContractId
          );
          if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
          } else {
            this.selectedCourses.forEach((item) => {
              item.ContractId = this.editingContractId;
            });

            this.$message.success("批量修改成功");
            this.showError = false;
            this.$emit("saveBatchCourseListSuccess");
            this.$emit("closeBatchCloseCourseListEditor");
          }
        } else {
          for (let i = 0; i < this.selectedCourses.length; i++) {
            if (this.batchSetType == "minute") {
              this.selectedCourses[i].CourseMinutes = this.editingCourseMinutes;
            } else if (this.batchSetType == "university") {
              this.selectedCourses[i].UniversityList =
                this.editingCourseUniversityList;
            } else if (this.batchSetType == "campus") {
              this.selectedCourses[i].CampusList = this.editingCourseCampusList;
            } else if (this.batchSetType == "contract") {
              this.selectedCourses[i].ContractId = this.editingContractId;
            }
          }

          let result = await batchSetSpeedUpCourseList(this.selectedCourses);
          if (result) {
            if (!result.success) {
              this.errorMessage = result.message;
              this.showError = true;
            } else {
              this.$message.success("批量修改成功");
              this.showError = false;
              this.$emit("saveBatchCourseListSuccess");
              this.$emit("closeBatchCloseCourseListEditor");
            }
          }
        }

        this.isSaving = false;
      }
    },
    reset() {
      this.editingCourseMinutes = 180;
      this.editingCourseUniversityList = [];
      this.editingCourseCampusList = [];
      this.editingContractId = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/batchCourseListEditor.vue